import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTabs from "./en-us/tabs.json";
import localizationEnUsInformation from "./en-us/information.json";
import localizationEnUsEmployees from "./en-us/employees.json";
import localizationEnUsModalBusinessUnit from "./en-us/modal-business-unit.json";
import localizationEnUsBusinessUnit from "./en-us/business-units.json";

export const localizationEnUsAccount = {
  ...localizationEnUsHeader,
  ...localizationEnUsTabs,
  ...localizationEnUsInformation,
  ...localizationEnUsEmployees,
  ...localizationEnUsModalBusinessUnit,
  ...localizationEnUsBusinessUnit,
};
